import { UserDto } from '../models/dto/user.dto';

export enum GendersEnum {
    Man = 'fd0dd0da-347d-484e-b8ea-6ba24160158c',
    Woman = '39fadfd4-fc9c-4c38-aa66-ad47ffaf14c0',
    NonBinary = '5869f0cd-a538-4172-90db-448c5c90f434',
}

export const enumToNameMap: Record<GendersEnum, string> = {
	[GendersEnum.Man]: 'Man',
	[GendersEnum.Woman]: 'Woman',
	[GendersEnum.NonBinary]: 'Non Binary',
}

export const getGendersEnumValueName = (value: GendersEnum): string => enumToNameMap[value];

export const getUserGenderToDisplay = (user: UserDto): string => {
	if (user.genderId) {
		return getGendersEnumValueName(user.genderId);
	}

	if (user.treatAsGenderId) {
		return `Treat as ${getGendersEnumValueName(user.treatAsGenderId)}`;
	}

	return '-';
}
